export const toggleKey = (checked, key, nextValue) => {
  const next = new Set(checked);
  if (nextValue) next.add(key);
  else next.delete(key);
  return next;
};

export const applyShiftRange = (visibleKeys, checked, anchorKey, targetKey, nextValue) => {
  const anchorIndex = visibleKeys.indexOf(anchorKey);
  const targetIndex = visibleKeys.indexOf(targetKey);
  if (anchorIndex === -1 || targetIndex === -1) return toggleKey(checked, targetKey, nextValue);
  const [from, to] = anchorIndex <= targetIndex ? [anchorIndex, targetIndex] : [targetIndex, anchorIndex];
  const next = new Set(checked);
  for (let index = from; index <= to; index += 1) {
    if (nextValue) next.add(visibleKeys[index]);
    else next.delete(visibleKeys[index]);
  }
  return next;
};

export const matchesFilter = (text, filter) => {
  const needle = String(filter == null ? '' : filter).trim().toLowerCase();
  if (needle === '') return true;
  return String(text == null ? '' : text).toLowerCase().includes(needle);
};
